import omitBy from 'lodash/omitBy'
import { createSelector } from 'reselect'

const newsSelector = (state) => state.news

export const createVisibleNewsSelector = (desiredNews) =>
  createSelector(newsSelector, (news) =>
    omitBy(news, (_, key) => !desiredNews.includes(key)),
  )
